// extracted by mini-css-extract-plugin
export var post = "Post-module--post--3qQx2";
export var post__category = "Post-module--post__category--2aq9_";
export var post__author = "Post-module--post__author--3e8Un";
export var post__cover = "Post-module--post__cover--38xoH";
export var post__title = "Post-module--post__title--_OhrE";